module.exports = __webpack_public_path__ + "static/media/SourceSansPro-It.56bd1a85.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-It.woff2
// module id = 336
// module chunks = 3